import { gql } from '@apollo/client'

export const GET_COMPANY_PRODUCT_CATEGORIES = gql`
  query GetCompanyProductCategories($companyId: ID) {
    companyProductCategories(companyId: $companyId) {
      id
      category
      parentCategory
    }
  }
`
